import { FunctionComponent } from 'react';
import BaseNotification from './BaseNotification';
import { NotificationCardProps } from './NotificationCard';

export type TestNotificationContext = {
  test: string;
  number: number;
};

const TestNotification: FunctionComponent<NotificationCardProps> = ({ notification, onClick, read }) => {
  const context = notification.propertyBag as TestNotificationContext;

  return (
    <BaseNotification
      title={'Test notification'}
      description={`Notification ${context.test}: ${context.number}`}
      date={notification.createdOn}
      read={read}
      link={'/notifications'}
      onClick={onClick}
    />
  );
};

export default TestNotification;
